import React from 'react';

import { Select, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { MenuItem } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: theme.typography.fontSizeMedium,
    fontWeight: theme.typography.fontWeightSemibold
  },
  menuItem: {
    width: '100%',
    maxWidth: '100%',
    fontSize: theme.typography.fontSizeMedium
  }
}));

interface IDropdownProps {
  disabled?: boolean,
  value?: string,
  items?: any[],
  placeholder?: string,
  onSelect: (value: string | undefined) => void
}
function Dropdown ({ disabled, value, items, placeholder, onSelect }: IDropdownProps) {
  const classes = useStyles();
  return (
    <FormControl
      disabled={disabled}
      variant='outlined'
      fullWidth
    >
      <Select
        className={classes.select}
        value={value}
        onChange={(event: any) => { onSelect(event.target.value); }}
      >
        {
          placeholder && (
            <MenuItem className={classes.menuItem} value='' disabled>
              {placeholder}
            </MenuItem>
          )
        }
        {items && items.map((item, index) => (
          <MenuItem className={classes.menuItem} value={item.value} key={index}>
            {item.content}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default Dropdown;
